var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("代理商小程序推广码：")]),_c('el-image',{staticClass:"img",attrs:{"fit":"contain","src":_vm.code}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }